import React from 'react';
import styles from './index.module.scss'
import { Container, Row, Col } from 'react-bootstrap';
import Facebook from '../../../assets/svg/facebook';
import Twitter from '../../../assets/svg/twitter';
import Instagram from '../../../assets/svg/instagram';
import Youtube from '../../../assets/svg/youtube';
import Whatsapp from '../../../assets/svg/whatsapp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';


const Footer = () => {
  
  return (
    <>
    <div className={styles.bookNow}>
      <a href="https://booking.statueofbelief.com">Book Now</a>
    </div>
    {/* <div className={styles.whatsapp}>
      <a href="https://api.whatsapp.com/send/?phone=+7877190351&text=Hello" target='_blank'><Whatsapp /></a>
    </div> */}
        <footer className={styles.footer}>
      <Container>
        <Row>
        <Col className={'col-6 order-lg-1 order-2'} lg={3} md={6}>
            <div className={styles.footerMenu}>
            <p><b>Park &amp; Stay</b></p>
            <ul>
              {/* <li><a href="/park-and-stay/136/offers-discount">Offers &amp; Discount</a></li> */}
              <li><a href="/park-and-stay/137/event-booking">Event Booking</a></li>
              <li><a href="/park-and-stay/138/group-booking">Group Booking</a></li>
              <li><a href="https://www.radissonhotels.com/en-us/hotels/radisson-nathdwara?facilitatorId=GOOGLECHAP&cid=a:ps+b:ggl+c:apac+i:brand+e:rad+d:ind+r:brt+f:en-US+g:ho+h:INRJUDR1+v:cf&gad=1&gclid=CjwKCAjwvdajBhBEEiwAeMh1U2aYW5WXUzPZEmr4ysh5Ro1XEb7ocKvTzSqWcQHRBl-eEZ6LXui26hoCupUQAvD_BwE&gclsrc=aw.ds" rel="nofollow" target='_blank'>Stay Facility</a></li>
              {/* <li><a href="/park-and-stay/140/corporate-schools">Corporate &amp; Schools</a></li> */}
            </ul>
            </div>
          </Col>
          <Col className={'col-6 order-lg-2 order-3 d-md-block d-none'} lg={3} md={6}>
          <div className={styles.footerMenu}>
            <p><b>Things To Do</b></p>
            <ul>
              <li><a href="https://booking.statueofbelief.com/" target='_blank'>Statue Visit</a></li>
              <li><a href="/attractions">Attractions</a></li>
              {/* <li><a href="/things-to-do/132/rides">Rides</a></li>
              <li><a href="/things-to-do/133/dining">Dining</a></li> */}
              <li><a href="/events">Events</a></li>
              {/* <li><a href="our-attractions/43/Souvenir%20&#038;%20Gift%20Shop">Shopping</a></li> */}
            </ul>
          </div>
          </Col>
          <Col className={'col-6 order-lg-3 order-4'} lg={3} md={6}>
            <div className={styles.footerMenu}>
              <p><b>Help</b></p>
              <ul>
                <li><a href="/help/124/visitors-guide">Visitor's Guide</a></li>
                <li><a href="/help/126/park-timing">Park Timing</a></li>
                {/* <li><a href="/help/tips-for-parents">Tips for Parents</a></li>
                <li><a href="/help/128/lost-found">Lost &amp; Found</a></li> */}
                {/* <li><a href="/help/129/rules-regulations">Rules &amp; Regulations</a></li> */}
                <li><a href="/help/130/cancellation-policy">Cancellation Policy</a></li>
              </ul>
            </div>
          </Col>
          <Col className={'order-lg-4 order-1 mb-lg-0 mb-4'} lg={3} md={6}>
            <div className="text-center">
              <img src="https://www.theindianthing.com/shiva-statue/wp-content/uploads/2023/05/logo-1.png" alt=""  loading="lazy"/>
              <ul className={styles.ulSocial}>
              <li>
                <a href="https://www.facebook.com/sob.offical/" target='_blank'><span className={styles.socialIcons}><Facebook /></span></a>
                </li>
                <li>
                <a href="https://twitter.com/statueofbelief" target='_blank'><span className={styles.socialIcons}><Twitter /></span></a>
                </li>
                <li>
                <a href="https://www.instagram.com/statue.of.belief/" target='_blank'><span className={styles.socialIcons}><Instagram /></span></a>
                </li>
                <li>
                <a href="https://www.youtube.com/@statueofbeliefoffical" target='_blank'><span className={styles.socialIcons}><Youtube /></span></a>
                </li>
              </ul>
              <p className={styles.textTollFree}><FontAwesomeIcon icon={faPhone} /><a href="tel:18001200351">1800-120-0351</a><span>(Toll Free)</span></p>
            </div>
          </Col>
        </Row>
        <ul className={styles.bottomUl}>
          <li>© 2024 Statue of Belief</li>
          <li><a href="/policies/121/privacy-policy">Privacy Policy</a></li>
          <li><a href="/policies/119/terms-conditions">Terms &amp; Conditions</a></li>
          <li><a href="/policies/120/disclaimer">Disclaimer</a></li>
          {/* <li><a href="/policies/122/sitemap">Sitemap</a></li> */}
        </ul>
      </Container>
    </footer>  
    </>  
  );
};

export default Footer;
